<template>
  <svg :style="style" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="icon_EDCxitong">
      <rect x="0.333984" width="24" height="24" rx="4" fill="white" />
      <path id="Vector"
        d="M13.0004 3.81895L5.63672 8.11411V16.705L13.0009 21.0002L20.364 16.705V8.1147L13.0004 3.81836V3.81895ZM16.8333 10.0578V13.2424H12.1823V11.6793H15.283V10.1162H10.632V14.8055H16.8327V16.3686H9.08164V8.55246H16.8327V10.0578H16.8333Z"
        fill="#FE553E" />
      <rect id="Rectangle 34624797" x="6.45508" y="7.09082" width="9.81818" height="9" fill="white" />
      <path id="Vector_2"
        d="M11.3636 3.00059L4 7.29575V15.8867L11.3642 20.1818L18.7273 15.8867V7.29634L11.3636 3V3.00059ZM15.1966 9.23947V12.424H10.5456V10.8609H13.6463V9.2978H8.99525V13.9871H15.196V15.5502H7.44492V7.7341H15.196V9.23947H15.1966Z"
        fill="#376EFF" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'edc-system',
  props: {
    fontSize: {
      type: String,
      default: '24px'
    }
  },
  data() {
    return {
      style: {
        width: '1em',
        height: '1em',
        'vertical-align': 'middle',
        fill: 'currentColor',
        overflow: 'hidden',
        'font-size': this.fontSize
      }
    }
  }
}
</script>